import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
// base/variants/sizes bor i buttonClasses.ts — se noten där om varför de
// inte ligger kvar i den här filen.
import { buttonClasses, type ButtonVariant, type ButtonSize } from './buttonClasses';


interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      leftIcon,
      rightIcon,
      loading,
      fullWidth,
      className,
      children,
      disabled,
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={buttonClasses({ variant, size, fullWidth, className })}
        {...rest}
      >
        {loading ? (
          <span className="inline-flex items-center gap-2">
            <span
              className="h-3.5 w-3.5 rounded-full border-2 border-current border-t-transparent animate-spin"
              aria-hidden
            />
            <span>Laddar…</span>
          </span>
        ) : (
          <>
            {leftIcon && (
              <span className="inline-flex shrink-0" aria-hidden>
                {leftIcon}
              </span>
            )}
            <span>{children}</span>
            {rightIcon && (
              <span className="inline-flex shrink-0" aria-hidden>
                {rightIcon}
              </span>
            )}
          </>
        )}
      </button>
    );
  },
);

Button.displayName = 'Button';
